import { useQuery } from '@tanstack/react-query';
import { BidvTransferDestWhitelistService } from 'services/openapi';

import { BidvBankTransferServiceKeys } from './constants';

export type DestWhitelistItem = {
  id: string;
  companyId?: string;
  companyName?: string;
  transferMethod: 'I' | 'O' | 'F';
  beneficiaryName: string;
  beneficiaryAccount: string;
  bankCode?: string;
  bankName?: string;
  createdAt?: string;
  updatedAt?: string;
};

export type DestWhitelistListResponse = {
  statusCode: number;
  message: string[];
  data: DestWhitelistItem[];
  total: number;
};

type ListDestWhitelistVariables = {
  companyId?: string;
  search?: string;
  transferMethod?: string;
  pageIndex?: number;
  pageSize?: number;
  [key: string]: any;
};

export const useListBidvTransferDestWhitelistQuery = (
  variables: ListDestWhitelistVariables = {},
) => {
  const {
    companyId,
    search,
    transferMethod,
    pageIndex = 0,
    pageSize = 20,
  } = variables;

  const queryKey = [
    BidvBankTransferServiceKeys.GET_TRANSFER_DEST_WHITELIST,
    variables,
  ];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<DestWhitelistListResponse, Error>({
    queryKey,
    queryFn: () =>
      BidvTransferDestWhitelistService.bidvTransferDestWhitelistControllerList(
        companyId || undefined,
        search || undefined,
        (transferMethod as 'I' | 'O' | 'F') || undefined,
        String(pageIndex + 1),
        String(pageSize),
      ) as unknown as Promise<DestWhitelistListResponse>,
    retry: 0,
    refetchOnWindowFocus: false,
    enabled: !!variables.fetchData,
  });

  return {
    isLoading,
    isLoadingError,
    isFetching,
    error,
    data,
    isError,
    queryKey,
    refetch,
  };
};
